import apiFetch from '../apiFetch'

export default function (listClientes, token) {
  return apiFetch({endPoint: `Ruta/getClientes`, method: 'POST', body: listClientes, token: token})
}
